import { useAuth } from '@clerk/clerk-react';
import { useMutation } from '@tanstack/react-query';
import { StorefrontApiError } from '../../../../lib/api/storefront-client.js';
import { validateCoupon } from '../api/coupons-api.js';

async function requireToken(getToken: () => Promise<string | null>): Promise<string> {
  const token = await getToken();
  if (!token) {
    throw new StorefrontApiError('AUTHENTICATION_ERROR', 'Your session has expired. Please sign in again.', 401);
  }
  return token;
}

/**
 * Validate-only coupon preview for the cart page's coupon input -- never
 * writes any coupon-application state server-side. The resolved code is
 * meant to be carried forward in local/session state and re-applied for
 * real at checkout, not persisted here.
 */
export function useCouponValidation() {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (code: string) => validateCoupon(code, { token: await requireToken(getToken) }),
  });
}
